import { useNavigate } from "react-router";
import { toast } from "sonner";
import { useAuth } from "./auth";
import { useSwitchOrganization } from "./use-switch-organization";

/**
 * Ir pra uma tela de OUTRA organização: troca a ativa e navega, com "Desfazer" (que volta à
 * organização e à tela de antes) em vez de confirmação prévia — reverter é trivial. Na própria
 * organização ativa, só navega. Usado pelo "Abrir em" de /organizacoes e pela busca global.
 */
export function useAbrirNaOrganizacao() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { switchTo, isSwitching } = useSwitchOrganization();

  const abrir = (organizationId: string, organizationName: string, href: string) => {
    if (isSwitching) return;
    const anterior = user?.activeOrganization?.id;
    if (organizationId === anterior) {
      navigate(href);
      return;
    }
    const telaAnterior = window.location.pathname + window.location.search;
    switchTo(organizationId)
      .then(() => {
        navigate(href);
        toast.success(`Você está em ${organizationName} agora`, {
          action: anterior
            ? {
                label: "Desfazer",
                onClick: () => {
                  switchTo(anterior)
                    .then(() => navigate(telaAnterior))
                    .catch((err) => toast.error(err.message || "Erro ao voltar pra organização anterior."));
                },
              }
            : undefined,
          duration: 5000,
        });
      })
      .catch((err) => toast.error(err.message || "Erro ao trocar de organização."));
  };

  return { abrir, abrindo: isSwitching };
}
